import { render, staticRenderFns } from "./Taobao-expend-create.vue?vue&type=template&id=46aef9f4&"
import script from "./Taobao-expend-create.vue?vue&type=script&lang=js&"
export * from "./Taobao-expend-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports